import React, { useState, useEffect } from 'react';
import { BreadCrumb, ListLayout } from '../../containers/Layout';
import { isEmpty, size } from 'lodash';

import { InputSelectMagasin } from '../../../../../commonModules/interface/form-input-inline';
import SingleReturnSale from '../../returns/SingleReturnSale';
import { TableRow, TableCell, Box, TableHead, TableBody, IconButton } from '@material-ui/core';
import { AddRounded, DeleteRounded } from '@material-ui/icons';
import { toast } from 'react-toastify';
import SingleShop from '../../shops/SingleShop';
import { useFetchTransfers } from '../../../../../../../../jsx/hooks/getTransfers';
import DeleteDialog from '../../../../../commonModules/interface/DeleteDialog';
import { useSelector } from 'react-redux';
import SingleTransferOccasionSale from './SingleTransferOccasionSale';

const ListTransferOccasionSale = (props) => {
    const SHOPS = useSelector((state) => state.inventory.shops); 
    const CLIENTS = useSelector((state) => state.inventory.clients); 
    const RETURNSALES = useSelector((state) => state.inventory.returnSales); 

    const [state, setState] = useState({
        view: 'list',
        sale: {},
        shop: {},
        client: {},

        deletePopUp: false,
        toDelete: {
            id: '',
        },

        pageOfItems: [],
        currentPage: 1,
        search: '',
        searchClass: 'custom-search',
        filteredList: [],
        reload: false,

        selectSearch: '',
        selectSearchDisplay: {
            value: '',
            label: 'Tous les Magasins',
        },
        view: 'list',
    });

    const fetchTransfers = useFetchTransfers("occasion_vente");

    useEffect(() => {
        if(isEmpty(RETURNSALES)){
            fetchTransfers();
        }
    }, []);

    const handleSale = (sale, shop, client) => {
        setState({
            ...state,
            view: 'sale',
            sale,
            shop,
            client,
        });
    };

    const handleClose = () => {
        setState({
        ...state,
        view: 'list',
        sale: {},
        shop: {},
        client: {},
        });
    };

    const handleDelete = (sale) => {
        setState({
            ...state,
            deletePopUp: true,
            toDelete: sale,
        });
    };

    const createSaleList = () => {

        return !isEmpty(RETURNSALES) && Object.keys(RETURNSALES).map((ID) => {
            const sale = RETURNSALES[ID];
            if (sale) {
                const client = CLIENTS[sale.client_id];
                const shop = SHOPS[sale.shop_id];
                return (
                    <TableRow key={sale.id}>
                        <TableCell>{new Date(sale.creation_date).toLocaleString('fr-FR')}</TableCell>
                        <TableCell>{sale.nature}</TableCell>
                        <TableCell>
                            <a href="#" onClick={() => props.handleSingleShop(shop)}>
                                {' '}
                                {shop.name}{' '}
                            </a>
                        </TableCell>
                        <TableCell>
                            {client && <span>{client.client_firstname} {client.client_lastname}</span>}
                        </TableCell>
                        <TableCell>
                            <IconButton color="secondary" onClick={() => handleSale(sale, shop, client)}>
                                <AddRounded />
                            </IconButton>
                        </TableCell>
                        <TableCell>
                            <IconButton
                                onClick={() => handleDelete(sale)}
                            >
                                <DeleteRounded color="error" />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                );
            }
        });
    };

    const displayList = () => {
        let listAll = [];
        let tab = [];
        let rows = 0;
        if (!isEmpty(RETURNSALES)) {
            let filteredList = filterList('');
            console.log('====================================');
            console.log({filteredList});
            console.log('====================================');
            rows = size(filteredList);
            tab = createSaleList(filteredList);
            listAll = filteredList &&  filteredList.map(sale => sale.id);
        }
        console.log('====================================');
        console.log({ list: tab, size: rows, listAll });
        console.log('====================================');
        return { list: tab, size: rows, listAll };
    };


    const createShopList = () => {
        const list = [{ value: '', label: 'Tous les Magasins' }];
        if (SHOPS) {
            Object.keys(SHOPS).map((ID) => {
                const shop = SHOPS[ID];
                list.push({ value: ID, label: shop.name });
            });
        }
        return list;
    };

    // const onChangePage = (pageOfItems, page) => {
    //     setState({ ...state, pageOfItems, currentPage: page });
    // };

    // const searchFilter = (search) => {
    //     let list = search ? shopFilter(search) : Object.keys(RETURNSALES);
    //     return list;
    // };

    // const handleSearch = async (e) => {
    //     const field = e.target.name;
    //     const value = e.target.value;
    //     setState({
    //         ...state,
    //         search: {
    //             ...state.search,
    //             [field]: value,
    //         },
    //     });
    //     const vProd = (state.search.searchProd).toLowerCase();
    //     let match = [];
    //     if (!isEmpty(RETURNSALES)) {
    //         await Object.values(RETURNSALES).map((sale) => {
    //             if ((vProd !== '' && sale.nature === vProd) || vProd === '') {
    //                 match.push(sale.id);
    //             }
    //         });
    //     }
    //     setState({
    //         ...state,
    //         sales: match,
    //     });
    // };

    const shopFilter = (selected) => {
        let filteredShop = Object.keys(RETURNSALES).filter((ID) => {
            return RETURNSALES[ID].shop_id === selected;
        });
        return filteredShop;
    };

    const filterList = (searchValue, selectedShop) => {
        let filteredList = selectedShop ? shopFilter(selectedShop) : Object.keys(RETURNSALES);
        // setState({
        //     ...state,
        //     filteredList,
        //     reload: !state.reload,
        // });
        return filteredList
    };

    const deleteSale = async () => {
        props
        .deleteReturnSale(state.toDelete.id)
        .then((e) => {
            toast.success(JSON.stringify(e));
        })
        .catch((e) => {
            toast.error('ERROR ' + JSON.stringify(e));
        });
    };
    const saleList = displayList();
    return (
        <Box>
            <BreadCrumb breadcrumb={props.breadcrumb} title="Sorties" back={props.handleClose} />
            {state.deletePopUp && !isEmpty(state.toDelete) && (
                <DeleteDialog
                    title={'Supprimer la vente n°' + state.toDelete.id}
                    handleSubmit={deleteSale}
                    close={() => setState({ ...state, deletePopup: false })}
                    open={true}
                />
            )}
            {state.view === 'sale' && !isEmpty(state.sale) && !props.showSingleShop && (
                <SingleTransferOccasionSale transfer={state.sale} shop={state.shop} client={state.client} handleCloseSale={handleClose} {...props} />
            )}
            {props.showSingleShop && <SingleShop shop={props.singleShop} {...props} occasion />}
            {state.view === 'list' && !props.showSingleShop && (
                <div>
                    <Box p={2}>
                        <InputSelectMagasin
                            options={createShopList()}
                            value={state.selectSearchDisplay}
                            label="Sélectionner un Magasin"
                            onChange={(option) => {
                                setState({ selectSearchDisplay: option, selectSearch: option.value });
                                filterList(state.search, option.value);
                            }}
                        />
                    </Box>
                    <ListLayout>
                        <TableHead>
                            <TableRow>
                                <TableCell>Date</TableCell>
                                <TableCell>Nature</TableCell>
                                <TableCell>Shop</TableCell>
                                <TableCell>Nom Client</TableCell>
                                <TableCell>Détails</TableCell>
                                <TableCell>Options</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            { saleList.size !== 0  && 
                                saleList.list
                            }
                        
                        {/* {state.filteredList.length !== 0 && createSaleList()} */}
                        {saleList.size === 0 && (
                            <TableRow>
                                <td colSpan="7">
                                    <div className="text-center">
                                        <h5>Pas encore de Ventes</h5>
                                    </div>
                                </td>
                            </TableRow>
                        )}
                        </TableBody>
                    </ListLayout>
                </div>
            )}
        </Box>
    );
};

export default ListTransferOccasionSale;
